import router from "../router";

/**
 * actions are functions that cause side effects and can involve asynchronous operations.
 */
export default {
  /**
   * Init Data
   * @param commit
   * @param dispatch
   * @param state
   * @param getters
   * @returns {Promise<void>}
   */
  initData: async () => {
    // if (getters['users/isLoggedIn']) {
    //   await dispatch('users/getUser')
    // }
  },

  backHome: async () => {
    await router.push({name: 'home'})
  },

  back: async () => {
    await router.back();
  },

  forward: async () => {
    await router.forward();
  },

  goLogin: async () => {
    await router.push({name: 'login'})
  },
}
